import React, { useState, useEffect } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import axios from 'axios';
import PropTypes from "prop-types";
import { Table, Badge, Button, Modal } from 'react-bootstrap';
import AddClients from './PopUps/Add/AddClients';
import EditClients from './PopUps/Edit/EditClients';
import * as Icon from 'react-feather';
import { canPageAction } from '../../config/roleConfig';
import DeactivateConfirmModal from '../Common/DeactivateConfirmModal';

const REGIMEN_FISCAL_LABELS = {
    '601': 'General de Ley PM',
    '603': 'PM Fines no Lucrativos',
    '605': 'Sueldos y Salarios',
    '606': 'Arrendamiento',
    '608': 'Demás ingresos',
    '610': 'Residentes en el Extranjero',
    '612': 'PF Act. Empresariales',
    '620': 'Soc. Cooperativas',
    '621': 'Incorporación Fiscal',
    '622': 'Act. Agrícolas/Ganaderas',
    '623': 'Grupos de Sociedades',
    '624': 'Coordinados',
    '625': 'Plataformas Tecnológicas',
    '626': 'RESICO',
};

const USO_CFDI_LABELS = {
    'G01': 'Adquisición de mercancías',
    'G02': 'Devoluciones/descuentos',
    'G03': 'Gastos en general',
    'I01': 'Construcciones',
    'I02': 'Mobiliario y equipo',
    'I03': 'Equipo de transporte',
    'I04': 'Equipo de cómputo',
    'I08': 'Otra maquinaria',
    'P01': 'Por definir',
    'S01': 'Sin efectos fiscales',
    'CP01': 'Pagos',
};

function NewTrips(props)  {
    const authHeader = useAuthHeader();
    const authUser = useAuthUser();
    const currentUser = authUser();
    const canRead = canPageAction(currentUser, 'sales.clients', 'read');
    const canWrite = canPageAction(currentUser, 'sales.clients', 'write');
    const canDelete = canPageAction(currentUser, 'sales.clients', 'delete');

    const [data, setData] = useState([]);
    const [expandedClient, setExpandedClient] = useState(null);
    const [clientToDeactivate, setClientToDeactivate] = useState(null);
    const [deactivatingClient, setDeactivatingClient] = useState(false);
    const apiUrl = process.env.REACT_APP_URL;

    const get_all_clients = () => {
        axios({
            method:'GET',
            url:apiUrl+'/finance/get_all_clients',
            headers: {
                Authorization: authHeader()
            },
        }).then(response => {
            setData(response.data.msg.Clients);
        })
        .catch(error => {
            alert(error);
        });
    }

    useEffect(() => {
        get_all_clients();
    }, []);

    const toggleClientDetails = (clientId) => {
        setExpandedClient(expandedClient === clientId ? null : clientId);
    };

    const deleteClient = (client) => {
        if (!client) {
            return;
        }

        setDeactivatingClient(true);
        axios({
            method: 'DELETE',
            url: apiUrl + '/finance/client',
            headers: {
                Authorization: authHeader()
            },
            data: { id: client.id }
        }).then(() => {
            setClientToDeactivate(null);
            get_all_clients();
        }).catch(error => {
            alert(error.response?.data?.error || 'No se pudo desactivar el cliente');
            console.log(error);
        }).finally(() => {
            setDeactivatingClient(false);
        });
    };

        return (
            <>
            <div className="card mb-4">
                <div className="card-body">
                    <div className="card-header d-flex justify-content-between">
                        <h5 className="card-title">Clientes</h5>
                        {canWrite && <AddClients setData={get_all_clients}/>}
                    </div>

                    {/* <div className="height-310"> */}
                    <div>
                        <Table className="m-0" responsive>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Razón Social</th>
                                    <th>RFC</th>
                                    <th>Régimen Fiscal</th>
                                    <th>Uso CFDI</th>
                                    <th>C.P.</th>
                                    <th>Email</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(client => (
                                    <>
                                        <tr key={client.id}>
                                            <td>{client.company_name}</td>
                                            <td>{client.legal_name}</td>
                                            <td>{client.rfc}</td>
                                            <td>{REGIMEN_FISCAL_LABELS[client.regimen_fiscal] || ''}</td>
                                            <td>{USO_CFDI_LABELS[client.uso_cfdi] || ''}</td>
                                            <td>{client.codigo_postal || ''}</td>
                                            <td>{client.email || ''}</td>
                                                <td>
                                                    <div className="d-flex gap-1">
                                                        {canRead && (
                                                            <Button
                                                                size="sm"
                                                                variant="outline-primary"
                                                                onClick={() => toggleClientDetails(client.id)}
                                                            >
                                                                <Icon.Eye size={14} />
                                                            </Button>
                                                        )}
                                                        {canWrite && <EditClients setData={get_all_clients} clientInfo={client}/>}
                                                        {canDelete && (
                                                            <Button
                                                                size="sm"
                                                                variant="outline-danger"
                                                                onClick={() => setClientToDeactivate(client)}
                                                            >
                                                                <Icon.Trash2 size={14} />
                                                            </Button>
                                                        )}
                                                        {!canRead && !canWrite && !canDelete && (
                                                            <span className="text-muted">N/A</span>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                            {expandedClient === client.id && (
                                                <tr>
                                                    <td colSpan={8}>
                                                        <div className="p-3 bg-light">
                                                            <div className="row">
                                                                <div className="col-md-4">
                                                                    <p><strong>Contacto:</strong> {client.contact_name || 'N/A'}</p>
                                                                    <p><strong>Teléfono:</strong> {client.phone_number || 'N/A'}</p>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <p><strong>Días de Pago:</strong> {client.days_to_pay || 'N/A'}</p>
                                                                    <p><strong>Email:</strong> {client.email || 'N/A'}</p>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <p><strong>RFC:</strong> {client.rfc || 'N/A'}</p>
                                                                    <p><strong>C.P.:</strong> {client.codigo_postal || 'N/A'}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            {client.contacts && client.contacts.length > 1 && client.contacts.slice(1).map((contact, index) => (
                                                <tr key={`${client.id}-${index}`}>
                                                <td colSpan={7} />
                                                <td></td>
                                                </tr>
                                            ))}
                                    </>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
            <DeactivateConfirmModal
                show={Boolean(clientToDeactivate)}
                title="Desactivar Cliente"
                itemLabel={clientToDeactivate?.company_name}
                confirming={deactivatingClient}
                onCancel={() => !deactivatingClient && setClientToDeactivate(null)}
                onConfirm={() => deleteClient(clientToDeactivate)}
            />
            </>
        );

}

//Status: Entregado, Pendiente, Cancelado, En camino
// Success, Warning, Danger, Info
//https://react-bootstrap.netlify.app/docs/components/badge/
export default NewTrips;
